import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash/get';

import TargetBox from './TargetBox';

const styles = theme => ({
  root: {
    '& > div > div': {
      display: 'inline-block',
      marginRight: 25,
      marginBottom: 10,
      verticalAlign: 'top',
    },
  },
  title: {
    marginBottom: 10,
  },
  body: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: '100%',
    justifyItems: 'center',
  },
});

const WeeklyTargets = ({ classes, planResult, showTitle = false }) => {
  const [gpTarget, setGpTarget] = React.useState(0);
  const [hcTarget, setHcTarget] = React.useState(0);
  const [uptTarget, setUptTarget] = React.useState(0);

  React.useEffect(() => {
    setGpTarget(get(planResult, 'targetWeeklyGp', '-'));
    setHcTarget(get(planResult, 'targetHourLyCustomers', '-'));
    setUptTarget(get(planResult, 'targetWeeklyUpt', '-'));
  }, [planResult]);
  return (
    <div className={classes.root}>
      {showTitle && (
        <Typography className={classes.title} variant="h5">
          This week's target
        </Typography>
      )}

      <div className={classes.body}>
        <div>
          <TargetBox justified label="GP$" value={`$${gpTarget}`} />
        </div>
        <div>
          <TargetBox justified label="Hourly Customers" value={hcTarget} />
        </div>
        <div>
          <TargetBox justified label="UPT" value={uptTarget} />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(WeeklyTargets);
